module.exports = __webpack_public_path__ + "media/landing_page/iframe_background-37cc57df.svg";